import { render } from "./Workspace.vue?vue&type=template&id=68480f16&scoped=true&ts=true"
import script from "./Workspace.vue?vue&type=script&lang=ts"
export * from "./Workspace.vue?vue&type=script&lang=ts"

import "./Workspace.vue?vue&type=style&index=0&id=68480f16&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68480f16"]])

export default __exports__